import { CharStreams, Token } from 'antlr4';
import { default as TableauExpressionLexer } from './gen-src/TableauExpressionLexer';
export function tokensFromTableauExpression(expression) {
    const input = CharStreams.fromString(expression);
    const lexer = new TableauExpressionLexer(input);
    lexer.removeErrorListeners();
    const tokens = [];
    let t = lexer.nextToken();
    while (t.type !== Token.EOF) {
        tokens.push(t);
        t = lexer.nextToken();
    }
    return tokens;
}
export function trimBrackets(expression) {
    const firstBracket = expression.indexOf('[');
    if (firstBracket !== -1) {
        const lastBracket = expression.lastIndexOf(']');
        if (lastBracket !== -1) {
            return unescapeBrackets(expression.substr(firstBracket + 1, lastBracket - firstBracket - 1));
        }
        else {
            return unescapeBrackets(expression.substr(firstBracket + 1));
        }
    }
    return expression;
}
function unescapeBrackets(expression) {
    return expression.replace(/]]/g, ']');
}
//# sourceMappingURL=helpers.js.map